import { GlModal } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { sprintf } from '@gitlab/ui/src/utils/i18n';
import { uniqueId } from 'lodash-es';
import { renderLeaveSuccessToast } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/projects_list/utils.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { s__, __ } from '~/locale';
import { deleteProjectMember } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/api/projects_api.js?vue3';
export default {
    name: 'ProjectsListItemLeaveModal',
    components: {
        GlModal
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            required: false,
            default: false
        },
        project: {
            type: Object,
            required: true
        }
    },
    emits: [
        'success',
        'change'
    ],
    data () {
        return {
            modalId: uniqueId('projects-list-item-leave-modal-'),
            isLoading: false
        };
    },
    modal: {
        actionCancel: {
            text: __('Cancel')
        }
    },
    computed: {
        title () {
            return sprintf(s__('Projects|Are you sure you want to leave "%{nameWithNamespace}"?'), {
                nameWithNamespace: this.project.nameWithNamespace
            });
        },
        actionPrimary () {
            return {
                text: s__('Projects|Leave project'),
                attributes: {
                    variant: 'danger',
                    loading: this.isLoading
                }
            };
        }
    },
    methods: {
        async handlePrimary () {
            this.isLoading = true;
            try {
                await deleteProjectMember(this.project.id, gon.current_user_id);
                this.$emit('success');
                renderLeaveSuccessToast(this.project);
            } catch (error) {
                createAlert({
                    message: s__('Projects|An error occurred while leaving the project. Please refresh the page to try again.'),
                    error,
                    captureError: true
                });
            } finally{
                this.isLoading = false;
            }
        }
    }
};
